import React, { useState } from 'react';

import { ProductHelper, ValidationHelper } from '../helpers';
import { AjaxForm } from './index.jsx';
import { ProductChoice } from './Product/index.jsx';

const ProductSearchForm = ({
    product,
    submitAction,
    readOnly = false,
    setCategory,
    filters,
}) => {
    const [ categoryId, setCategoryId ] = useState(filters?.category_id)
    const [ brandId, setBrandId ] = useState(filters?.brand_id)

    const initialValues = product || !filters ?
      ProductHelper.getInitialValues(product) :
      filters
    const validationSchema = ValidationHelper.schema([])

    const formProps = {
        initialValues,
        validationSchema,
        submitAction,
        submitContainerClassName : brandId ?
            'move-right-search-products-submit-row' :
            '',
        submitLabel: 'Search',
        allowFormReset: true,
    }

    const handleCategoryChange = (categoryId) => {
      setCategoryId(categoryId);
      setCategory?.(categoryId);
    }

    return (
        <AjaxForm {...formProps} enableReinitialize>
            <ProductChoice
                product={product}
                readOnly={readOnly}
                fromSearch={true}
                showHeaders={false}
                onCategoryChanged={(c) => setCategoryId(c)}
                onBrandChanged={(b) => setBrandId(b)}
                onSearchQueryChange={submitAction}
            />
        </AjaxForm>
    )
}

export default ProductSearchForm
